import React, { useState, useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import './AdminDashboard.css';
import AdminPage from '../Maps/AdminPage';
import Category from '../Store/Category/Category';
import Vendor from '../Store/Vendors/Vendor';
import ItemPage from '../Store/Items/Items';
import NewsletterForm from '../NewsLetter/NewsletterForm';
import { AuthContext } from '../../../App';
import { FaHome, FaStore, FaMapMarkedAlt, FaChartBar, FaChevronUp, FaChevronDown, FaChevronLeft, FaChevronRight,FaRegNewspaper } from 'react-icons/fa';
import checkLoginStatusAPI from '../../API/checkLoginStatus';
import { IoNewspaperOutline } from "react-icons/io5";
import MapsLogs from '../MapsLogs/MapsLogs';
import ChatGPTInterface from '../Chatbot/Chatbot';
import { FaRobot } from 'react-icons/fa';

import { FaClipboardList } from 'react-icons/fa';
import VisitorAnalyticsPage from '../Homepage/VisitorAnalyticsPage';


const SidebarMenu = () => {
  const { isLoggedIn, updateLoginStatus } = useContext(AuthContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [activePage, setActivePage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyLoginStatus = async () => {
      const result = await checkLoginStatusAPI();
      updateLoginStatus(result.isLoggedIn);
      setLoading(false);
    };

    verifyLoginStatus();
  }, [updateLoginStatus]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (window.innerWidth <= 800 && !event.target.closest('.sb-menu__sidebar')) {
        setActiveSubMenu(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleSubMenu = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };


  
  const renderPage = () => {
    switch(activePage) {
      case 'home':
        return <VisitorAnalyticsPage />;
      case 'Maps':
        return <AdminPage />;
      case 'categories':
        return <Category />;
      case 'vendors':
        return <Vendor />;
      case 'products':
        return <ItemPage />;
      case 'newsletter':
        return <NewsletterForm />;
      case 'apiLogs':
        return <MapsLogs />;
      case 'chatbot':
        return <ChatGPTInterface />;
      default:
        return (
          <>
            <p>Welcome to the Admin Dashboard</p>
          </>
        );
    }
  };  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="sb-menu__page-container">
      <nav className={`sb-menu__sidebar ${isSidebarOpen ? '' : 'sb-menu__close'}`}>
        <ul className="sb-menu__list">
          <li className="sb-menu__item sb-menu__logo-item">
            <span className="sb-menu__logo">Admin Dashboard</span>
            <button onClick={toggleSidebar} className="sb-menu__toggle-btn">
            {isSidebarOpen ? <FaChevronLeft size={24} /> : <FaChevronRight size={24} />}
            </button>
          </li>
          <li className="sb-menu__item">
            <button onClick={() => setActivePage('home')} className="sb-menu__dropdown-btn">
              <FaHome size={24} />
              <span>Home</span>
            </button>
          </li>
          <li className="sb-menu__item">
            <button
              onClick={() => toggleSubMenu(0)}
              className={`sb-menu__dropdown-btn ${activeSubMenu === 0 ? 'sb-menu__active' : ''}`}
            >
              <FaStore size={24} />
              <span>Store</span>
              {activeSubMenu === 0 ? <FaChevronUp size={18} /> : <FaChevronDown size={18} />}
            </button>
            <ul className={`sb-menu__sub-menu ${activeSubMenu === 0 ? 'sb-menu__show' : ''}`}>
              <div>
                <li><a href="#" onClick={() => setActivePage('orders')} className="sb-menu__sub-link">Orders</a></li>
                <li><a href="#" onClick={() => setActivePage('products')} className="sb-menu__sub-link">Products</a></li>
                <li><a href="#" onClick={() => setActivePage('payments')} className="sb-menu__sub-link">Payments</a></li>
                <li><a href="#" onClick={() => setActivePage('categories')} className="sb-menu__sub-link">Categories</a></li>
                <li><a href="#" onClick={() => setActivePage('vendors')} className="sb-menu__sub-link">Vendors</a></li>
              </div>
            </ul>
          </li>
          <li className="sb-menu__item">
            <button onClick={() => setActivePage('Maps')} className="sb-menu__dropdown-btn">
              <FaMapMarkedAlt size={24} />
              <span>Maps</span>
            </button>
          </li>
          <li className="sb-menu__item">
            <button onClick={() => setActivePage('newsletter')} className="sb-menu__dropdown-btn">
              <IoNewspaperOutline size={24} />
              <span>Newsletter</span>
            </button>
          </li>
          <li className="sb-menu__item">
            <button onClick={() => setActivePage('apiLogs')} className="sb-menu__dropdown-btn">
              <FaClipboardList size={24} />
              <span>API Logs</span>
            </button>
          </li>
          <li className="sb-menu__item">
            <button onClick={() => setActivePage('analytics')} className="sb-menu__dropdown-btn">
              <FaChartBar size={24} />
              <span>Analytics</span>
            </button>
          </li>
          <li className="sb-menu__item">
  <button onClick={() => setActivePage('chatbot')} className="sb-menu__dropdown-btn">
    <FaRobot size={24} />
    <span>Chatbot</span>
  </button>
</li>
        </ul>
      </nav>
      <main className="sb-menu__main-content">
        {renderPage()}
      </main>
    </div>
  );
};

export default SidebarMenu;
